import { Injectable, inject, signal } from '@angular/core';
import { firstValueFrom } from 'rxjs';

import { environment } from '../../../environments/environment';
import { AuthToggleService } from './auth/auth-toggle.service';

@Injectable({ providedIn: 'root' })
export class AppConfigService {
    private readonly authToggle = inject(AuthToggleService);

    public readonly loginObrigatorio = signal<boolean>(true);
    public readonly apiUrl = signal<string>(environment.apiUrl);

    public async carregar(): Promise<void> {
        try {
            const resposta = await firstValueFrom(this.authToggle.consultar());
            if (resposta.dados !== null) {
                this.loginObrigatorio.set(resposta.dados);
            }
        } catch {
            console.error('Falha ao verificar status de autenticação. Login será exigido por padrão.');
        }
    }
}
